import { Quiz, QuizMeta } from "@garther/interfaces";
import { useI18n } from "@garther/ui/libs";

export function formatCurrency(value: string | number): string {
  const numberValue = typeof value === "string" ? parseFloat(value) : value;

  if (isNaN(numberValue)) {
    return "Invalid value";
  }

  return new Intl.NumberFormat("vi-VN", {
    style: "currency",
    currency: "VND",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(numberValue);
}

/**
 * Utility function to get question meta by current language
 * @param question - The quiz question object
 * @returns The meta data for the current language, or fallback to English
 */
export const getQuestionMeta = (question: Quiz): QuizMeta => {
  const { currentLanguage } = useI18n();

  // Get meta for current language, fallback to English if not available
  const meta = question.meta[currentLanguage] || question.meta.en;

  return meta!;
};

/**
 * Utility function to get question text by current language
 * @param question - The quiz question object
 * @returns The question text for the current language, or fallback to English
 */
export const getQuestionText = (question: Quiz): string => {
  const meta = getQuestionMeta(question);
  return meta?.question || "Question not available";
};
